module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w-full justify-end items-center mb-3"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "px-2.5 py-1 bg-gray-50 hover:bg-gray-100 border border-solid border-gray-200 rounded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transfer_to_is_selected),
      expression: "transfer_to_is_selected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.transfer_to_is_selected) ? _vm._i(_vm.transfer_to_is_selected, null) > -1 : (_vm.transfer_to_is_selected)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.transfer_to_is_selected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.transfer_to_is_selected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.transfer_to_is_selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.transfer_to_is_selected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Transfer to")])]), _vm._v(" "), _c('button', {
    staticClass: "px-2.5 py-1 bg-gray-50 hover:bg-gray-100 border border-solid border-gray-200 rounded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invite_to_is_selected),
      expression: "invite_to_is_selected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.invite_to_is_selected) ? _vm._i(_vm.invite_to_is_selected, null) > -1 : (_vm.invite_to_is_selected)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.invite_to_is_selected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.invite_to_is_selected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.invite_to_is_selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.invite_to_is_selected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Invite CoTeacher")])]), _vm._v(" "), (_vm.transfer_to_is_selected || _vm.invite_to_is_selected) ? _c('div', {
    staticClass: "w-96"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_email),
      expression: "user_email"
    }],
    staticClass: "w-full px-1.5 py-1 border border-solid border-gray-200 rounded",
    attrs: {
      "type": "text",
      "placeholder": _vm.transfer_to_is_selected === true ? 'Enter teacher email to transfer the courses...' : 'Enter teacher email to invite him for the courses...'
    },
    domProps: {
      "value": (_vm.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user_email = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.transfer_to_is_selected || _vm.invite_to_is_selected) ? _c('button', {
    staticClass: "px-2.5 py-1 bg-primary border border-solid border-primary hover:bg-primary-dark text-white rounded",
    on: {
      "click": function($event) {
        return _vm.handleClick(_vm.transfer_to_is_selected === true ? 'transfer' : 'invite')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.transfer_to_is_selected === true ? 'Transfer Courses' : 'Invite'))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "details-list"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.user.courses), function(course, index) {
    return _c('div', {
      key: index,
      staticClass: "detail-item"
    }, [_c('div', {
      staticClass: "text-left flex items-center space-x-2",
      class: course.teachers.includes(_vm.getProfile.id) || _vm.getCurrentSchool.id === course.school_id || _vm.systemWide ? 'portfolio-link cursor-pointer' : 'not-clickable'
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCourses),
        expression: "selectedCourses"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": course.id,
        "checked": Array.isArray(_vm.selectedCourses) ? _vm._i(_vm.selectedCourses, course.id) > -1 : (_vm.selectedCourses)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedCourses,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = course.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCourses = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCourses = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCourses = $$c
          }
        }, function($event) {
          return _vm.handleSelection(course.id)
        }]
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "flex",
      attrs: {
        "href": course.link,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.goToCourse(course)
        }
      }
    }, [_vm._v("\n          " + _vm._s(course.title) + "\n          "), (course.teachers.includes(_vm.getProfile.id) || _vm.getCurrentSchool.id === course.school_id || _vm.systemWide) ? _c('i', {
      staticClass: "fas fa-external-link-alt"
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8 flex justify-between row"
    }, [_c('span', {
      staticClass: "col-xs-4 tc"
    }, [_vm._v("\n          " + _vm._s(course.is_archived ? 'Archived' : 'Active') + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "col-xs-3 tc"
    }, [_vm._v("\n          " + _vm._s(course.number_students) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "col-xs-2 tc"
    }, [_vm._v("\n          " + _vm._s(course.count_roundtable) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "col-xs-1 tc"
    }, [_vm._v("\n          " + _vm._s(course.count_live) + "\n        ")])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('span', {
    staticClass: "b course-header"
  }, [_vm._v("Name & Section")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 flex justify-between row"
  }, [_c('span', {
    staticClass: "col-xs-4 b course-header"
  }, [_vm._v("Status")]), _vm._v(" "), _c('span', {
    staticClass: "col-xs-3 b course-header"
  }, [_vm._v("Students")]), _vm._v(" "), _c('span', {
    staticClass: "col-xs-2 b course-header"
  }, [_vm._v("Written")]), _vm._v(" "), _c('span', {
    staticClass: "col-xs-1 b course-header"
  }, [_vm._v("Verbal")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2a5875c6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/userDetailsModal/coursesTabContent.vue
// module id = 2047
// module chunks = 61